import { useTranslation } from 'react-i18next';
import { BV, formatVP } from '../../../../../../helpers/helperFunctions';
import {
  CaptionText,
  H3,
  H4,
  H5,
  P1,
  P2,
  P3
} from '../../../../../../styles/FontStyles';
import {
  Flexed,
  SectionSeparator
} from '../../../../../../styles/GlobalComponents';
import { color } from '../../../../../../styles/GlobalStyles';
import styled from 'styled-components';

const LegInfoWrapperHeader = styled.div`
  background: ${({ theme }) => theme.colors.neutral900};
  border-radius: 15px 15px 0 0;
  padding: 4px 15px;
`;

const LegInfoWrapper = styled.div`
  background: ${({ theme }) => theme.colors.neutral100};
  border-radius: 0 0 15px 15px;
  padding: 8px 15px;
`;

export const LegInfo = ({ legName, legInfo, todayLegTotalVolume }) => {
  const { t } = useTranslation('myTeam');
  return (
    <div>
      <LegInfoWrapperHeader>
        <P3 bold color={color.colors.neutral0} center>
          {legName}
        </P3>
      </LegInfoWrapperHeader>
      <LegInfoWrapper>
        <CaptionText color={color.colors.neutral700}>
          Business Volume
        </CaptionText>

        <H4 color={color.colors.neutral700}>
          {formatVP(legInfo?.legTotalVolume) ?? 0} {BV} <br />
        </H4>

        {todayLegTotalVolume >= 0 && (
          <CaptionText color={color.colors.primary900}>
            +{formatVP(todayLegTotalVolume)}{' '}
            <span
              style={{
                color: color.colors.neutral500
              }}>
              {t('today')}
            </span>
            {''}
          </CaptionText>
        )}

        <SectionSeparator margin={'12px 0'} />

        <Flexed width='100%'>
          <Flexed column width='50%'>
            <CaptionText color={color.colors.neutral700}>
              {t('total_downline')}{' '}
            </CaptionText>

            <H4 color={color.colors.neutral700}>{legInfo?.totalDownline}</H4>
          </Flexed>
          <Flexed column width='50%'>
            <CaptionText color={color.colors.neutral700}>
              {t('total_directs')}{' '}
            </CaptionText>

            <H4 color={color.colors.neutral700}>
              {legInfo?.totalDirectUsersCount}
            </H4>
          </Flexed>
        </Flexed>
        <Flexed width='100%'>
          <Flexed column width='50%'>
            <CaptionText color={color.colors.primary900}>
              +{legInfo?.todayTotalDownline}{' '}
              <span
                style={{
                  color: color.colors.neutral500
                }}>
                {t('today')}
              </span>
            </CaptionText>
          </Flexed>
          <Flexed column width='50%'>
            <CaptionText color={color.colors.primary900}>
              +{legInfo?.todayTotalDirectUsersCount}{' '}
              <span
                style={{
                  color: color.colors.neutral500
                }}>
                {t('today')}
              </span>
            </CaptionText>
          </Flexed>
        </Flexed>
      </LegInfoWrapper>
    </div>
  );
};
